@if (author) {
    <div [attr.data-preview-id]="author.preview_id">
        <sew-ws-stage-headline-rotation small>
            @if (heroPictureURL) {
                <sew-picture object-fit slot="picture" show-image [src]="heroPictureURL"> </sew-picture>
            }
            <h1>
                <span>{{ author.firstname + ' ' + author.surname }}</span>
                <span>{{ author.company_position }}</span>
            </h1>
        </sew-ws-stage-headline-rotation>
        @if (breadcrumbs.length > 0) {
            <sew-ws-breadcrumb [links]="breadcrumbs" no-margin="true"></sew-ws-breadcrumb>
        }
        @if (!author.content.length && env.preview) {
            <blog-fs-add-section
                style="position: absolute; left: 50%; transform: translateX(-50%); z-index: 300"
                [previewId]="author.preview_id"
                [label]="addSectionLbl ?? ''"
            ></blog-fs-add-section>
        }
        <!-- content -->
        <blog-content
            style="margin: 0 auto"
            [contents]="author.content"
            [breakpoint]="breakpoint"
        ></blog-content>
        <!-- all articles of author -->
        @if (allPosts.length) {
            <blog-connected-article-list
                [breakpoint]="breakpoint"
                [articles]="allPosts"
                [header]="labelAllArticles"
                [imgSrc]="'assets/images/round_icons/all_articles.svg'"
            ></blog-connected-article-list>
        }
    </div>
}
